var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningNoBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35672_3511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 16.4476C11.3285 16.4476 10.7661 17.0101 10.7661 17.681C10.7661 18.352 11.3285 18.9144 11.9995 18.9144C12.6458 18.9144 13.2329 18.352 13.2033 17.7106C13.2329 17.0051 12.6754 16.4476 11.9995 16.4476Z",
    fill: "#F7C500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.416 20.8188C24.1906 19.4818 24.1955 17.8882 23.4259 16.5562L15.6999 3.17632C14.9352 1.82945 13.5538 1.03021 12.0046 1.03021C10.4555 1.03021 9.07409 1.83438 8.30939 3.17138L0.573551 16.566C-0.196086 17.9129 -0.191152 19.5163 0.588352 20.8533C1.35799 22.1755 2.73446 22.9698 4.27373 22.9698H19.7059C21.2501 22.9698 22.6365 22.1656 23.416 20.8188ZM21.7386 19.8518C21.3094 20.5918 20.5496 21.0309 19.701 21.0309H4.2688C3.43009 21.0309 2.67525 20.6017 2.2559 19.8765C1.83161 19.1414 1.82668 18.2632 2.25097 17.5231L9.98681 4.13343C10.4062 3.39833 11.1561 2.96417 12.0046 2.96417C12.8483 2.96417 13.6031 3.40326 14.0225 4.13836L21.7534 17.5281C22.1678 18.2484 22.1629 19.1167 21.7386 19.8518Z",
    fill: "#F7C500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6939 7.78922C11.1068 7.95696 10.7417 8.48978 10.7417 9.13608C10.7713 9.52583 10.796 9.92052 10.8256 10.3103C10.9094 11.7953 10.9933 13.2507 11.0772 14.7357C11.1068 15.2389 11.4965 15.604 11.9998 15.604C12.503 15.604 12.8977 15.2142 12.9223 14.7061C12.9223 14.4002 12.9223 14.119 12.9519 13.8082C13.0062 12.856 13.0654 11.9038 13.1197 10.9516C13.1493 10.3349 13.2036 9.71824 13.2332 9.10154C13.2332 8.87953 13.2036 8.68219 13.1197 8.48485C12.8681 7.93229 12.281 7.65108 11.6939 7.78922Z",
    fill: "#F7C500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35672_3511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningNoBackground);
export default __webpack_public_path__ + "static/media/warning_noBackground.1b880e96844cd2190fe303447dd9d076.svg";
export { ForwardRef as ReactComponent };